







import moment from 'moment';
import Vue from 'vue';

export default Vue.extend({
  props: ['value', 'label'],
  data() {
    return {
      date: this.value,
      menu: false,
    };
  },
  methods: {
    updateDate() {
      this.menu = false;
      this.$emit('update', this.date);
    },
  },
});
